<template>
  <div
    v-if="hasStats"
    class="outreach-contact-social-stats"
  >
    <div
      v-for="stat in statKeys"
      :key="stat"
      class="outreach-contact-social-stats-row"
    >
      <div class="outreach-contact-social-stats-row__title">
        <OutreachContactStatLabel
          :contact="contact"
          suffix=":"
          :type="stat"
        />
      </div>

      <OutreachContactStat
        :contact="contact"
        :type="stat"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import OutreachContactStat from "shared/components/Outreach/OutreachContact/OutreachContactStat.vue";
import OutreachContactStatLabel from "shared/components/Outreach/OutreachContact/OutreachContactStatLabel.vue";
import { type ContactType } from "shared/composables/useContact";
import {
  type OutreachContactStatKey,
  useOutreachContactSocialStats,
} from "shared/composables/useOutreachContactSocialStats";

interface OutreachContactSocialStatsProps {
  contact: ContactType;
}

const props = defineProps<OutreachContactSocialStatsProps>();

const { stats, hasStats } = useOutreachContactSocialStats(props);

const statKeys = computed<OutreachContactStatKey[]>(
  () => Object.keys(stats.value) as OutreachContactStatKey[]
);
</script>

<style lang="scss" scoped>
.outreach-contact-social-stats {
  display: flex;
  flex-direction: column;
  gap: var(--s-spacing-lg);

  &-row {
    display: flex;
    align-items: center;
    gap: var(--s-spacing-md);
    font-size: var(--s-font-size-md);
    line-height: 150%;

    &__title {
      font-weight: 500;
      color: var(--s-color-denim-7);
      text-decoration: dotted underline;
    }

    &__no-data {
      .base-outreach-contact-stat {
        padding: 2.5px 8px;
        background: rgb(0 0 0 / 8%);
        border-radius: 16px;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.16px;
        color: var(--s-color-denim-9);

        &:hover {
          color: unset;
        }
      }

      .q-icon {
        color: var(--s-color-denim-5);
      }
    }
  }
}
</style>
